import Audio from '@/lib/audio.js';
import Cards from '@/lib/cards.js';
import { mountVueComponent } from '@/lib/mount-vue-component';
import QuickManager from '@/lib/components/QuickManager/QuickManager.vue';
import VideoThumbnails from '@/lib/video-thumbnails.js';
import Vue from 'vue';

export default function () {
	const cards = new Cards();
	cards.setup('ul.cards:not(.vertical-gallery)', 'li', 'fitRows');

	const audio = new Audio();
	audio.setup('jp-jplayer');

	const videoThumbnails = new VideoThumbnails();
	videoThumbnails.setup('preview-container.video');

	const quickManager = document.getElementById('quickManager');

	if (quickManager) {
		new Vue({
			el: quickManager,
			name: 'QuickManagerApp',
			components: {
				'quick-manager': QuickManager,
			},
		});
	}

	import('@/lib/components/Video/VideoPlayer.vue').then((videoPlayer) => {
		mountVueComponent('video-player', videoPlayer);
	});

	import('@/lib/components/Video/VideoModal.vue').then((videoModal) => {
		mountVueComponent('video-modal', videoModal);
	});

	import('@/lib/components/Shared/PdfViewer/PdfViewer.vue').then((pdfViewer) => {
		mountVueComponent('pdf-viewer', pdfViewer);
	});

	import('@/lib/components/Fields/AIAgentField.vue').then((aiAgentField) => {
		mountVueComponent('ai-agent-field', aiAgentField);
	});
}
